import {Component, ViewChild} from "@angular/core";
import {NavController, NavParams, ActionSheet, Slides} from 'ionic-angular';
import {InAppBrowser} from 'ionic-native';
import {HowToPage} from '../how-to/how-to';
//

@Component({
  templateUrl: 'build/pages/results/results.html'
})
export class ResultsPage {

  protect = [];
  protectList = [];
  restore = [];
  restoreList = [];

  protectButton = '';
  protectTitle = '';
  protectImg = '';
  protectLink = '';
  protectListClass = '';
  protectTable = [];

  footTitle = '';
  footImg = '';
  footLink = '';
  footTable = [];

  restoreTitle = '';
  restoreImg = '';
  restoreLink = '';

  applications = [
    "Specific Oil Based & Mechanical Components",
    "Specific Adherant Contaminants",
    "Specific Water Based Contaminants",
    "Universal Oil & Water Based Contaminants",
    "Occlusive Workplace Footwear",
    "Occlusive Workplace Gloves",
    "UVA & UVB sun Rays",
    "UVC Artificial Rays",
    "Cold & Frost Conditions"
  ];



  constructor( private nav: NavController, private navParams: NavParams ) {
    this.nav = nav;
    this.navParams = navParams;

    if (this.navParams.get('gloves') === 10) {

      this.protect.push({
        title: 'Ansell Triple Active Gel',
        image: './img/triple_active_gel.png',
        link: 'http://www.arco.co.uk/branchloc',
        button: 'Contact Us',
        listClass: 'application-list hide',
        list: []
      });

      this.protectList.push({
        text: 'Ansell Triple Active Gel',
        handler: () => {
          this.protectTitle = 'Ansell Triple Active Gel';
          this.protectImg = './img/triple_active_gel.png';
          this.protectLink = 'http://www.arco.co.uk/branchloc';
          this.protectButton = 'Contact Us';
          this.protectListClass = 'application-list hide';
          this.protectTable = [];
        }
      });

    } else {

      if (this.navParams.get('protectWhere') === 0 || this.navParams.get('protectWhere') === 10) {

        this.protect.push({
          title: 'Stokoderm® Sun Protect 30 Pure',
          image: './img/stokoderm_sun_protect_30_pure.png',
          link: 'http://www.arco.co.uk/products/2769020',
          button: 'View Product',
          listClass: 'application-list show',
          list: [this.applications[6], this.applications[7]]
        });

        this.protectList.push({
          text: 'Stokoderm® Sun Protect 30 Pure',
          handler: () => {
            this.protectTitle = 'Stokoderm® Sun Protect 30 Pure';
            this.protectImg = './img/stokoderm_sun_protect_30_pure.png';
            this.protectLink = 'http://www.arco.co.uk/products/2769020';
            this.protectButton = 'View Product';
            this.protectListClass = 'application-list show';
            this.protectTable = [this.applications[6], this.applications[7]];
          }
        });

        if (this.navParams.get('protectWhere') === 0) {

          this.protect.push({
            title: 'Stokoderm® Sun Protect 50+',
            image: './img/stokoderm_sun_protect_50+.png',
            link: 'http://www.arco.co.uk/product?productcode=2769070',
            button: 'View Product',
            listClass: 'application-list show',
            list: [this.applications[6]]
          });

          this.protectList.push({
            text: 'Stokoderm® Sun Protect 50+',
            handler: () => {
              this.protectTitle = 'Stokoderm® Sun Protect 50+';
              this.protectImg = './img/stokoderm_sun_protect_50+.png';
              this.protectLink = 'http://www.arco.co.uk/product?productcode=2769070';
              this.protectButton = 'View Product';
              this.protectListClass = 'application-list show';
              this.protectTable = [this.applications[6]];
            }
          });

        }

      } else if (this.navParams.get('protectWhere') === 5 || this.navParams.get('protectWhere') === 15) {

        this.protect.push({
          title: 'Stokoderm® Frost',
          image: './img/stokoderm_frost.png',
          link: 'http://www.arco.co.uk/products/2769068',
          button: 'View Product',
          listClass: 'application-list show',
          list: [this.applications[8]]
        });

        this.protectList.push({
          text: 'Stokoderm® Frost',
          handler: () => {
            this.protectTitle = 'Stokoderm® Frost';
            this.protectImg = './img/stokoderm_frost.png';
            this.protectLink = 'http://www.arco.co.uk/products/2769068';
            this.protectButton = 'View Product';
            this.protectListClass = 'application-list show';
            this.protectTable = [this.applications[8]];
          }
        });

      }

      if (this.navParams.get('protectWhat') === 40 || this.navParams.get('protectWhat') === 50) {

        this.protect.push({
          title: 'Travabon® Classic',
          image: './img/travabon_classic.png',
          link: 'http://www.arco.co.uk/products/2769062',
          button: 'View Product',
          listClass: 'application-list show',
          list: [this.applications[0]]
        });

        this.protectList.push({
          text: 'Travabon® Classic',
          handler: () => {
            this.protectTitle = 'Travabon® Classic';
            this.protectImg = './img/travabon_classic.png';
            this.protectLink = 'http://www.arco.co.uk/products/2769062';
            this.protectButton = 'View Product';
            this.protectListClass = 'application-list show';
            this.protectTable = [this.applications[0]];
          }
        });

      } else if (this.navParams.get('protectWhat') === 10) {

        this.protect.push({
          title: 'Stokoderm® Protect Pure',
          image: './img/stokoderm_protect_pure.png',
          link: 'http://www.arco.co.uk/products/2769017',
          button: 'View Product',
          listClass: 'application-list show',
          list: [this.applications[3]]
        });

        this.protectList.push({
          text: 'Stokoderm® Protect Pure',
          handler: () => {
            this.protectTitle = 'Stokoderm® Protect Pure';
            this.protectImg = './img/stokoderm_protect_pure.png';
            this.protectLink = 'http://www.arco.co.uk/products/2769017';
            this.protectButton = 'View Product';
            this.protectListClass = 'application-list show';
            this.protectTable = [this.applications[3]];
          }
        });

        if (this.navParams.get('gloves') === 5) {

          this.protect.push({
            title: 'Stokoderm® Grip Pure',
            image: './img/stokoderm_grip_pure.png',
            link: 'http://www.arco.co.uk/products/2760101',
            button: 'View Product',
            listClass: 'application-list show',
            list: [this.applications[3], this.applications[5]]
          });

          this.protectList.push({
            text: 'Stokoderm® Grip Pure',
            handler: () => {
              this.protectTitle = 'Stokoderm® Grip Pure';
              this.protectImg = './img/stokoderm_grip_pure.png';
              this.protectLink = 'http://www.arco.co.uk/products/2760101';
              this.protectButton = 'View Product';
              this.protectListClass = 'application-list show';
              this.protectTable = [this.applications[3], this.applications[5]];
            }
          });

        } else if (this.navParams.get('gloves') === 0) {

          this.protect.push({
            title: 'Stokoderm® Advanced',
            image: './img/stokoderm_advanced.png',
            link: 'http://www.arco.co.uk/products/2769064',
            button: 'View Product',
            listClass: 'application-list show',
            list: [this.applications[3]]
          });

          this.protectList.push({
            text: 'Stokoderm® Advanced',
            handler: () => {
              this.protectTitle = 'Stokoderm® Advanced';
              this.protectImg = './img/stokoderm_advanced.png';
              this.protectLink = 'http://www.arco.co.uk/products/2769064';
              this.protectButton = 'View Product';
              this.protectListClass = 'application-list show';
              this.protectTable = [this.applications[3]];
            }
          });

        }

      } else if (this.navParams.get('protectWhat') === 20) {

        this.protect.push({
          title: 'Stokoderm® Aqua Pure',
          image: './img/stokoderm_aqua_pure.png',
          link: 'http://www.arco.co.uk/products/G112662',
          button: 'View Product',
          listClass: 'application-list show',
          list: [this.applications[2]]
        });

        this.protectList.push({
          text: 'Stokoderm® Aqua Pure',
          handler: () => {
            this.protectTitle = 'Stokoderm® Aqua Pure';
            this.protectImg = './img/stokoderm_aqua_pure.png';
            this.protectLink = 'http://www.arco.co.uk/products/G112662';
            this.protectButton = 'View Product';
            this.protectListClass = 'application-list show';
            this.protectTable = [this.applications[2]];
          }
        });

      } else if (this.navParams.get('protectWhat') === 30) {

        this.protect.push({
          title: 'Travabon® Special Pure',
          image: './img/travabon_special_pure.png',
          link: 'http://www.arco.co.uk/products/2769066',
          button: 'View Product',
          listClass: 'application-list show',
          list: [this.applications[0], this.applications[1]]
        });

        this.protectList.push({
          text: 'Travabon® Special Pure',
          handler: () => {
            this.protectTitle = 'Travabon® Special Pure';
            this.protectImg = './img/travabon_special_pure.png';
            this.protectLink = 'http://www.arco.co.uk/products/2769066';
            this.protectButton = 'View Product';
            this.protectListClass = 'application-list show';
            this.protectTable = [this.applications[0], this.applications[1]];
          }
        });

      }

    }

    if (this.navParams.get('foot') === 1) {

      this.footTitle = 'Stokoderm® Foot Care';
      this.footImg = './img/stockoderm_foot_care.png';
      this.footLink = 'http://www.arco.co.uk/products/2760119';
      this.footTable = [this.applications[4]];

    }

    if (this.navParams.get('restore') === 0) {

      this.restore.push({
        title: 'Stokolan® Light Pure',
        image: './img/stokolan_light_pure.png',
        link: 'http://www.arco.co.uk/products/2769029'
      });

      this.restoreList.push({
        text: 'Stokolan® Light Pure',
        handler: () => {
          this.restoreTitle = 'Stokolan® Light Pure';
          this.restoreImg = './img/stokolan_light_pure.png';
          this.restoreLink = 'http://www.arco.co.uk/products/2769029';

        }
      });

      this.restore.push({
        title: 'Stokolan® Light Gel',
        image: './img/stokolan_light_gel.png',
        link: 'http://www.arco.co.uk/products/2769060'
      });

      this.restoreList.push({
        text: 'Stokolan® Light Gel',
        handler: () => {
          this.restoreTitle = 'Stokolan® Light Gel';
          this.restoreImg = './img/stokolan_light_gel.png';
          this.restoreLink = 'http://www.arco.co.uk/products/2769060';

        }
      });

    } else if (this.navParams.get('restore') === 5) {

      this.restore.push({
        title: 'Stokolan® Hand & Body',
        image: './img/stockolan_hand_body.png',
        link: 'http://www.arco.co.uk/products/2769057'
      });

      this.restoreList.push({
        text: 'Stokolan® Hand & Body',
        handler: () => {
          this.restoreTitle = 'Stokolan® Hand & Body';
          this.restoreImg = './img/stockolan_hand_body.png';
          this.restoreLink = 'http://www.arco.co.uk/products/2769057';

        }
      });

    } else if (this.navParams.get('restore') === 10) {

      this.restore.push({
        title: 'Stokolan® Sensitive Pure',
        image: './img/stokolan_sensitive_pure.png',
        link: 'http://www.arco.co.uk/products/2760117'
      });

      this.restoreList.push({
        text: 'Stokolan® Sensitive Pure',
        handler: () => {
          this.restoreTitle = 'Stokolan® Sensitive Pure';
          this.restoreImg = './img/stokolan_sensitive_pure.png';
          this.restoreLink = 'http://www.arco.co.uk/products/2760117';

        }
      });

    } else if (this.navParams.get('restore') === 15) {

      this.restore.push({
        title: 'Stokolan® Classic',
        image: './img/stokolan_classic.png',
        link: 'http://www.arco.co.uk/products/2769078'

      });

      this.restoreList.push({
        text: 'Stokolan® Classic',
        handler: () => {
          this.restoreTitle = 'Stokolan® Classic';
          this.restoreImg = './img/stokolan_classic.png';
          this.restoreLink = 'http://www.arco.co.uk/products/2769078';

        }
      });

    } else if (this.navParams.get('restore') === 20) {

      this.restore.push({
        title: 'Stokolan® Intense',
        image: './img/stokolan_intense.png',
         link: 'http://www.arco.co.uk/products/2769076'


      });

      this.restoreList.push({
        text: 'Stokolan® Intense',
        handler: () => {
          this.restoreTitle = 'Stokolan® Intense';
          this.restoreImg = './img/stokolan_intense.png';
           this.restoreLink = 'http://www.arco.co.uk/products/2769076';

        }
      });

    }
    this.protectList.push({
      text: 'Cancel',
      role: 'cancel',
      handler: () => {}
    });

    this.restoreList.push({
      text: 'Cancel',
      role: 'cancel',
      handler: () => {}
    });

    this.protectTitle = this.protect[0].title;
    this.protectImg = this.protect[0].image;
    this.protectLink = this.protect[0].link;
    this.protectButton = this.protect[0].button;
    this.protectTable = this.protect[0].list;
    this.protectListClass = this.protect[0].listClass;

    this.restoreTitle = this.restore[0].title;
    this.restoreImg = this.restore[0].image;
    this.restoreLink = this.restore[0].link;



  }

  // pushTest = this.testing[0];
  glovesVal = this.navParams.get('gloves');
  footVal = this.navParams.get('foot');
  protectWhereVal = this.navParams.get('protectWhere');
  protectWhatVal = this.navParams.get('protectWhat');
  restoreVal = this.navParams.get('restore');

  darth_fader() {
        document.getElementById('popbg').classList.toggle('fadeInbg');
        document.getElementById('pop1').classList.toggle('fadeIn');
        document.getElementById('pop2').classList.toggle('fadeIn');
    }

// For restore items

    restoreAction() {
      if (this.restoreLink !== 'unavailable'){
        this.launch(this.restoreLink);
      } else {
        //  this.darth_fader();
         document.getElementById('popbg').classList.toggle('fadeInbg');
         document.getElementById('pop1').classList.toggle('fadeIn');
         document.getElementById('pop2').classList.toggle('fadeIn');
      }

    }

// For protect items

    restoreActionProtect() {
      if (this.protectLink != 'unavailable'){
        this.launch(this.protectLink);
      } else {
        //  this.darth_fader();
         document.getElementById('popbg').classList.toggle('fadeInbg');
         document.getElementById('pop1').classList.toggle('fadeIn');
         document.getElementById('pop2').classList.toggle('fadeIn');
      }

    }


  nextPage(){
    this.nav.setRoot(HowToPage, {}, {animate: true, direction: 'back'});
  }

  type: string = "protect";

  protectActionSheet() {
    let actionSheet = ActionSheet.create({
      title: 'Options',
      buttons: this.protectList
    });

    this.nav.present(actionSheet);
  }

  restoreActionSheet() {
    let actionSheet = ActionSheet.create({
      title: 'Options',
      buttons: this.restoreList
    });

    this.nav.present(actionSheet);
  }

  launch(url) {
    InAppBrowser.open(url, '_system', 'location=true');
  }

  SliderOptions = {
    initialSlide: 0,
    onlyExternal: true
  };



  @ViewChild('mySlider') slider: Slides;

  switchLeftClass = 'switch switch-left fade';
  switchRightClass = 'switch switch-right';

  slidePrev() {
    this.slider.slidePrev();
    this.switchLeftClass = 'switch switch-left fade';
    this.switchRightClass = 'switch switch-right';
  }

  slideNext() {
    this.slider.slideNext();
    this.switchLeftClass = 'switch switch-left';
    this.switchRightClass = 'switch switch-right fade';
  }




}
